import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  statsLoadSuccess,
  statsLoadFailure,
  statsCampaignLoadSuccess,
  statsCampaignLoadFailure,
  addNotification
} from '../actions'
import { uiHelper } from '../../helpers'

export function* statsLoadSaga() {
  try {
    const result = yield axios.get(uris.stats)
    yield put(statsLoadSuccess(result.data))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(statsLoadFailure(uiHelper.errorMessage(error)))
  }
}

export function* statsCampaignLoadSaga(action) {
  try {
    const result = yield axios.get(`${uris.stats}/${action.payload}/emails`)
    yield put(statsCampaignLoadSuccess(result.data))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(statsCampaignLoadFailure(uiHelper.errorMessage(error)))
  }
}
